<template>
	<div class="app-container home" v-loading="loading">
		<div style="width: 100%;height: 340px;">
			<div ref="fireChart" style="width: 100%; height: 100%;"></div>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			fireDataList: {
				type: [Array, Object],
				default: [],
			},
		},
		name: "index",
		data() {
			return {
				list: [],
				loading: false,
			};
		},
		watch: {
			fireDataList(val) {
				this.loading = true;

				// console.log("🚀 ~ file: fireHydrant.vue:24 ~ fireDataList ~ val:", val);
				this.list = val.fireHydrantData;

				setTimeout(() => {
					this.lineChart(this.fireDataList.waterHeight, this.fireDataList.ciLower, this.fireDataList.ciCap);
				}, 800);
			},
		},
		mounted() {
			// const newData = this.fireDataList.map((item=>item.fireHydrantData.timeStr))
			// this.init();
			// setTimeout(() => {
			// 	this.lineChart(this.fireDataList.waterHeight, this.fireDataList.ciLower, this.fireDataList.ciCap);
			// }, 800);
		},

		methods: {
			lineChart(waterHeight, ciLower, ciCap) {
				// log(waterHeight, ciLower, 333);
				const fireHydrantLineTitle = this.list.map((item) => item.timeStr);
				const fireHydrantLineData = this.list.map((item) => item.value);
				const fireWaterHeight = waterHeight;
				const fireWaterLower = ciLower;
				// log(fireHydrantLineTitle, fireHydrantLineData, fireWaterHeight, fireWaterLower, 222);
				this.init(fireHydrantLineTitle, fireHydrantLineData, fireWaterHeight, fireWaterLower); // 时间  数值
			},
			// 用于Echarts 字体适配大屏
			chartsRelativeSize(percent, derection) {
				var windowW = this.$refs.fireChart.offsetWidth;
				var windowH = this.$refs.fireChart.offsetHeight;
				var r = 0;
				if ("h" === derection) {
					r = (percent * windowH) / 100;
				} else {
					r = (percent * windowW) / 100;
				}
				return r;
			},
			init(fireHydrantLineTitle, fireHydrantLineData, fireWaterHeight, fireWaterLower) {
				let fireChart = this.$echarts.init(this.$refs.fireChart);
				let echartOption1 = {
					title: {
						text: "室外消火栓",
						subtext: "水压(MPa)", //副标题文本
						left: this.chartsRelativeSize(1, "r"),
						top: this.chartsRelativeSize(1.5, "r"),
						textStyle: {
							fontSize: this.chartsRelativeSize(1, "r"),
						},
					},
					dataZoom: [
						{
							start: 0,
							type: "inside",
						},
						{
							type: "slider",
							start: 0,
						},
					],
					tooltip: {
						trigger: "axis",
					},
					calculable: false, //图形固定不能移动
					grid: {
						left: this.chartsRelativeSize(2, "r"),
						right: this.chartsRelativeSize(2, "r"),
						bottom: this.chartsRelativeSize(0.9, "r"),
						top: this.chartsRelativeSize(4.5, "r"),
						containLabel: true,
					},
					xAxis: [
						{
							type: "category",
							boundaryGap: false, // 从最左端开始
							axisLine: {
								lineStyle: {
									type: "solid",
									color: "#aaaaaa", //左边线的颜色
									width: "1", //坐标线的宽度
								},
							},
							axisLabel: {
								interval: 0,
								textStyle: {
									color: "#aaaaaa", //坐标值得具体的颜色
								},
							},
							axisTick: false,
							data: fireHydrantLineTitle,
						},
					],
					yAxis: [
						{
							type: "value",
							axisLine: {
								lineStyle: {
									type: "solid",
									color: "61a0a8", //左边线的颜色
								},
							},
							axisLabel: {
								textStyle: {
									color: "#aaaaaa", //坐标值得具体的颜色
								},
							},
							axisTick: false,
							splitLine: {
								//坐标轴在grid区域中的分隔线（网格中的横线）
								show: true,
								lineStyle: {
									width: 1,
									type: "solid",
								},
							},

							max: fireWaterHeight, // 水位
							splitArea: {
								//坐标轴在grid区域中的分隔区域（间隔显示网格区域）
								// interval: 0, //显示间隔的规律
								// show: true,
								areaStyle: {
									//分隔区域的样式
									color: ["rgba(255,255,255,0.03)", "rgba(255,255,255,0)"],
								},
							},
						},
					],
					series: [
						{
							name: "水压(MPa)",
							type: "line",
							lineGap: 0.2,
							lineWidth: this.chartsRelativeSize(0.8, "r"),
							areaStyle: {
								normal: {
									color: "#a7cd556e", //改变区域颜色
								},
							},
							itemStyle: {
								normal: {
									show: true,
									color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
										{
											offset: 0,
											color: "#a7cd55",
										},
										{
											offset: 1,
											color: "#a7cd55",
										},
									]),
									lineBorderRadius: this.chartsRelativeSize(1.1, "r"),
								},
								lineStyle: {
									color: "#a7cd55", //改变折线颜色
								},
							},
							data: fireHydrantLineData,

							markPoint: {
								//设置标记点
								data: [
									{
										type: "max",
										name: "最大值",
										symbol: "none",
										symbolSize: 25,
										itemStyle: {
											//设置标记点的样式
											normal: { color: "red" },
										},
									},
									{
										type: "min",
										name: "最小值",
										symbol: "none",
										symbolSize: 20,
										itemStyle: {
											//设置标记点的样式
											normal: { color: "blue" },
										},
									},
								],
							},
							markLine: {
								data: [
									{
										yAxis: this.fireDataList.waterHeight,
										itemStyle: {
											normal: { borderType: "dotted", color: "#1e9dff" },
										},
									},
									{
										yAxis: this.fireDataList.ciCap,
										itemStyle: {
											normal: { borderType: "dotted", color: "#ff1d00" },
										},
									},
									{
										yAxis: this.fireDataList.ciLower,
										itemStyle: {
											normal: { borderType: "dotted", color: "#ff1d00" },
										},
									},
								],
							},
						},
					],
				};

				fireChart.setOption(echartOption1);
				this.loading = false;
				//根据窗口的大小变动图表
				window.onresize = function() {
					fireChart.resize();
					// myChart1.resize();    //若有多个图表变动，可多写
				};
			},
		},
	};
</script>
